import {INITIAL_MIXER_REAL_SETTING} from './const';

import type AgoraClient from '../networklib/AgoraClient';

/** 各ミキサーごとの最終的なボリューム値を格納する */
export const RealMixer: Parameters<
  InstanceType<typeof AgoraClient>['importEngineMasterVolume']
>[0] = [...INITIAL_MIXER_REAL_SETTING] as const;

export const setstateForHeliModule = (text: string) => {
  const status = document.getElementById('status');
  if (!status) return;
  status.innerHTML = text;
};
export const defineSetstateForHeliModule = () => {
  if (globalThis.HeliModule !== undefined) {
    globalThis.HeliModule.setstate = setstateForHeliModule;
  }
};
